export const REPORT_STATE_SELECTOR = "reportGamers";
export const REPORT_COLUMNS_KEY = "[REPORT ==> gamers] Visible columns is:";
export const REPORT_DATE_KEY = "[REPORT ==> gamers] Date range is: ";
